import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../state'

@ngCore.Component({
  imports: [ngCommon.NgClass, ds.notice.icon.Component],
  selector: 'atn-platform-toaster',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  public readonly toasterFeature = ngCore.inject(state.display.toaster.Feature)

  public dismiss(id: state.display.toaster.models.Toast.Id): void {
    this.toasterFeature.actions.dismiss
      .from('Platform.Toaster.Toast.Close.Clicked')
      .dispatch({ id })
  }

  public clickAction(
    toastId: state.display.toaster.models.Toast.Id,
    actionId: state.display.toaster.models.Toast.Action['id'],
  ): void {
    this.toasterFeature.actions.clickAction
      .from('Platform.Toaster.Toast.Action.Clicked')
      .dispatch({ actionId, toastId })
  }
}
